import {
  FormData as PrepaymentFormData,
  formTools as prepaymentFormTools,
  notificationsConfig as prepaymentNotificationsConfig,
} from '../prepayment.form-tools';
import { PrepaymentFormFields } from './prepayment.form-fields';
import { FormDialog } from 'shared/ui/form-dialog';
import * as React from 'react';
import { useEffect } from 'react';
import { useCreateOrEditDialog } from 'hooks/create-or-edit-dialog.hook';
import { CreatePrepaymentDto, PrepaymentDto, UpdatePrepaymentDto } from '@sr/dto';
import { useActionCreators, useStateSelector } from 'shared/store';
import { useAddPrepayment, useUpdatePrepayment } from '../prepayment.hook';
import { prepaymentDialogActions } from './prepayment-dialog.slice';
import { Period } from 'entities/period-picker/types';
import { useSnack } from 'shared/ui/snack';
import { extractNestJsErrorMessage } from 'shared/api/rtk-query';

interface Props {
  prepayment: React.MutableRefObject<PrepaymentDto | null>;
  selectedPeriod?: Period;
  onSuccess?: () => void;
}

export const PrepaymentDialogForm = ({ prepayment, selectedPeriod, onSuccess }: Props) => {
  const isDialogOpened = useStateSelector(state => state.ui.prepaymentDialog.isPrepaymentDialogOpened);
  const { closeDialog: closePrepaymentDialog } = useActionCreators(prepaymentDialogActions);
  const { showSuccess, showError } = useSnack(prepaymentNotificationsConfig);

  const addPrepayment = useAddPrepayment();
  const updatePrepayment = useUpdatePrepayment();

  const handleAdd = async (dto: CreatePrepaymentDto) => {
    try {
      await addPrepayment(dto);
      showSuccess('Аванс успешно добавлен');
      if (onSuccess) onSuccess();
    } catch (error) {
      showError('Ошибка при добавлении аванса');
      throw extractNestJsErrorMessage(error);
    }
  };

  const handleUpdate = async (dto: UpdatePrepaymentDto) => {
    try {
      await updatePrepayment(dto);
      showSuccess('Аванс успешно обновлен');
      if (onSuccess) onSuccess();
    } catch (error) {
      showError('Ошибка при обновлении аванса');
      throw extractNestJsErrorMessage(error);
    }
  };

  const {
    dialogProps,
    openToAdd,
    openToEdit,
    itemToEdit,
  } = useCreateOrEditDialog<PrepaymentDto & { id: number },
    CreatePrepaymentDto,
    UpdatePrepaymentDto,
    PrepaymentFormData>({
      formTools: prepaymentFormTools,
      addHandler: handleAdd,
      updateHandler: handleUpdate,
      notificationsConfig: prepaymentNotificationsConfig,
    });

  useEffect(() => {
    if (!isDialogOpened) {
      return;
    }
    if (prepayment && prepayment.current) {
      openToEdit(prepayment.current);
    } else {
      openToAdd();
    }
    closePrepaymentDialog();
  }, [isDialogOpened, prepayment]);

  if (selectedPeriod) {
    dialogProps.initialValues.period = selectedPeriod;
  }

  return (
    <FormDialog<PrepaymentFormData>
      {...dialogProps}
      renderTitle={!itemToEdit ? 'Создание аванса': 'Редактирование аванса'}
      renderForm={(props) => {
        return <PrepaymentFormFields {...props} isNew={!itemToEdit} />;
      }}
    />
  );
};